var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.content,"placement":"top"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._t("content")]},proxy:true}],null,true)},[_c('i',{staticClass:"el-icon-info",style:(_setup.iconStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }